import { render, staticRenderFns } from "./CollectiblesTab.vue?vue&type=template&id=7452aedc&"
import script from "./CollectiblesTab.vue?vue&type=script&lang=ts&"
export * from "./CollectiblesTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports